/* eslint-disable */

import { useTranslation } from "react-i18next";

interface Props {
  imageEn: string;
  imageEs: string;
  altEn?: string;
  altEs?: string;
  className?: string;
}

const LocalizedTitleImage = ({
  imageEn,
  imageEs,
  className = "",

}: Props) => {
  const { t } = useTranslation();

  const isEnglish = t("zonas.ver.gal") === "View gallery"; // o cualquier string conocido

  const imageSrc = isEnglish ? imageEn : imageEs;
  const langClass = isEnglish ? "en" : "es";

  return (
    <img
      src={imageSrc}
      className={`${className}-${langClass}`.trim()}
    />
  );
};

export default LocalizedTitleImage;